module.exports = __webpack_public_path__ + "img/logo-peninsula.9e2122aa.png";